import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { NamirasoftAPIProductServer, ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { NamirasoftSupportServer } from "namirasoft-support";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { SupportLayout } from "./SupportLayout";
import { SupportRoutes } from "./SupportRoutes";
import CategoryListPage from "./pages/CategoryListPage";
import CategoryViewPage from "./pages/CategoryViewPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import TicketEditPage from "./pages/TicketEditPage";
import TicketListPage from "./pages/TicketListPage";
import TicketViewPage from "./pages/TicketViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_SUPPORT}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_SUPPORT = new EnvService("REACT_APP_BASE_URL_SUPPORT", true).getString();
            let REACT_APP_BASE_URL_API_PRODUCT = new EnvService("REACT_APP_BASE_URL_API_PRODUCT", true).getString();

            let support = new NamirasoftSupportServer(REACT_APP_BASE_URL_SUPPORT, result.account.token_manager, result.notifier.onError);
            let api_product = new NamirasoftAPIProductServer(REACT_APP_BASE_URL_API_PRODUCT, result.notifier.onError);

            let servers = { support, api_product };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows => (<Routes>
                        <Route path={SupportRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                        <Route path={SupportRoutes.TicketList} element={<TicketListPage {...result} servers={servers} />} />
                        <Route path={SupportRoutes.TicketNew} element={<TicketEditPage {...result} servers={servers} isEdit={false} />} />
                        <Route path={SupportRoutes.TicketCopy(":id")} element={<TicketEditPage {...result} servers={servers} isEdit={false} />} />
                        <Route path={SupportRoutes.TicketView(":id")} element={<TicketViewPage {...result} servers={servers} />} />

                        <Route path={SupportRoutes.CategoryList} element={<CategoryListPage {...result} servers={servers} />} />
                        <Route path={SupportRoutes.CategoryView(":id")} element={<CategoryViewPage {...result} servers={servers} />} />

                        {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                        <Route path="*" element={<NSNotFoundPage />} />
                    </Routes >))}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={SupportRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <SupportLayout
                {...props}
            >
                {props.children}
            </SupportLayout>
        )}
        requirement={{
            verification: {
                email: false,
                phone: false
            }
        }}
    />
}

export default Router;